import './button.scss';

type TButton = {
	children?: any;
	text: string;
	onClick?: any;
	gtmClass?: 'primary' | 'secondary'
	type?: 'button' | 'submit' | 'reset';
	className?: string;
	disabled?: boolean;
}

const Button = ({ children, onClick, gtmClass = "primary", type, text, className, disabled = false }: TButton) => {
	return (
		<button
			disabled={disabled}
			type={type || 'button'}
			className={`button button--${gtmClass} ${className ? className : ''}`}
			onClick={onClick || (() => { })}>
			{children || text}
		</button>
	)
}

export default Button